import { render, staticRenderFns } from "./ExtrusionReceiptForm.vue?vue&type=template&id=41866d06&scoped=true"
import script from "./ExtrusionReceiptForm.vue?vue&type=script&lang=js"
export * from "./ExtrusionReceiptForm.vue?vue&type=script&lang=js"
import style0 from "./ExtrusionReceiptForm.vue?vue&type=style&index=0&id=41866d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41866d06",
  null
  
)

export default component.exports